import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const HeaderWrapper = styled.div`
  display: flex;
  gap: ${Spacing.S12};
  padding: ${Spacing.S8} ${Spacing.S16};
  border-top: 1px solid ${Color.Grey150};
  background-color: ${Color.Grey100};
`
